module.exports = __webpack_public_path__ + "img/RCT04.14aab5d8.svg";